const activeStatuses = ["ACTIVE", "WARRANTY"];

export default activeStatuses;
